import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User } from "../model/user";
import { LocalVariable } from '../_helpers/localvariable'
import { Observable, of } from 'rxjs';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { IsInfo } from '../_helpers/isInfo';
import { Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  constructor(private http: HttpClient, private router: Router, public isLoggedInSingleton: IsInfo, private titleService: Title) { 
	this.isLoggedInSingleton.checkInfo();
	this.titleService.setTitle("Login - VirtualRacesFrance"); 
  }
  public email: string;
  public password: string;
  public loading = false;
  public error = false;
  public errorMessage;
  private authUrl = environment.endpoint + '/auth';
  faUser = faUser;


	async login() {
		let that = this;
		this.loading = true;
		let user = new User(this.email, this.password);
		await this.http.post<any>(this.authUrl, user).subscribe({
			next : data => {
				if (window.localStorage) {
					LocalVariable.saveAuth(data, this.email);
				}
			},
			error: err => {
				this.loading = false;
				this.password = '';
				this.error = true;
				if(err.status == 409){
					this.errorMessage = err.error;
				}else{
					this.errorMessage = "An error occured, please try again or contact support";
				}
			},
			complete: () => {
				this.loading = false;
				LocalVariable.checkLogIn(this.router);
			}
		});
	
  	}
  
  ngOnInit(): void {
	LocalVariable.checkLogIn(this.router);
  }

}
